import React, { useState, useEffect } from 'react';
import { Table, Image, Button, Pagination, Message, Modal, Radio, Loading, Tooltip } from '@yisa/webui';
import { QuestionCircleOutlined } from '@yisa/webui/es/Icon'
import { ResultFlow, BigImgSwitch, FormTreeSelect, FormSelect, FormInput, ExportModal } from '@/components';
import { useBoolean } from "ahooks";
import { character } from "@/utils";
import ajax from '@/services';
import errorPng from "@/assets/images/error.png"
import noPng from "@/assets/images/no.png"
import ROIModal from "./ROIModal"
import './index.scss'

// 设备管理
function Equipment(props) {
  const {
    type
  } = props

  // 原始表单
  const defaultFormData = {
    module_type: type,
    // 所属单位
    business_name: [],
    // 设备名称
    device_name: [],
    // 设备编号
    device_id: "",
    // 设备状态
    device_state: "",
    // 设备位置
    device_address: "",
    // 页码
    page: 1,
    // 数据量
    page_size: character.pageSizeOptions[0],
  }

  const [formData, setFormData] = useState(defaultFormData)
  const [lastFormData, setLastFormData] = useState(formData)
  const [loading, { setTrue, setFalse }] = useBoolean(false)
  const [tableScrollY, setTableScrollY] = useState(200);
  // 编辑弹窗
  const [editVisible, setEditVisible] = useState({
    visible: false,
    visible1: false,
    data: {}
  })
  const [editView0Visible, setEditView0Visible] = useState(false);
  const [editView1Visible, setEditView1Visible] = useState(false);
  useEffect(() => {
    setEditView0Visible(editVisible.visible);
  }, [editVisible.visible])
  useEffect(() => {
    setEditView1Visible(editVisible.visible1);
  }, [editVisible.visible1])
  // 经营单位列表
  const [businessList, setBusinessList] = useState([])
  // 抓拍设备列表
  const [devisceList, setDevisceList] = useState([])
  const [locList, setLocList] = useState([])
  // 表单修改
  const changeValue = (v, k) => {
    setFormData(Object.assign({}, formData, { [k]: v }))
  }
  const [resultData, setResultData] = useState({
    list: [],
    total: 0
  })

  const [imgLoading, setImgLoading] = useState(-1)
  const [bigImgData, setBigImgData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [bigImgVisible, setBigImgVisible] = useState(false);

  // 导出
  const [exportVisible, setExportVisible] = useState(false)
  const columns = [
    {
      title: "设备名称",
      dataIndex: "device_name",
      align: "center",
    },
    {
      title: "所属单位",
      dataIndex: "business_name",
      align: "center",
    },

    {
      title: "经营单位类别",
      dataIndex: "business_type",
      align: "center",
    },
    {
      title: "设备编号",
      dataIndex: "device_id",
      align: "center",
    },
    {
      title: "设备状态",
      dataIndex: "device_state",
      align: "center",
      render: (text) => {
        return <span className={text === 1 ? "state1" : "state2"}>{text === 1 ? "在线" : "离线"}</span>
      }
    },
    {
      title: "算法信息",
      dataIndex: "alg_names",
      align: "alg_names",
      render: (names) => {
        names = Array.isArray(names) ? names : []
        const nameList = <ul>
          {
            names.map(name => {
              return <li>
                {name}
              </li>
            })
          }
        </ul>
        return <span className="alg-name">
          算法配置
          {
            !!names.length && <Tooltip title={nameList}>
              <QuestionCircleOutlined />
            </Tooltip>
          }
        </span>
      }
    },
    {
      title: "抓图",
      dataIndex: "loc_img",
      align: "center",
      width: 190,
      render: (text) => {
        let src = text ? text : noPng
        return <div className='warn_img'>
          <Image src={src} errorSrc={errorPng}
            onClick={() => {
              if (text) {
                setBigImgVisible(true);
                setCurrentIndex(0);
                setBigImgData([src])
              }
            }} />
        </div>
      }
    },
    {
      title: "操作",
      dataIndex: "capture_correct_num",
      align: "center",
      width: 110,
      render: (text, record, index) => {
        let loc_id = locList.filter(v => v.label == record.loc_name).length ? locList.filter(v => v.label == record.loc_name)[0].value : ""
        return <div className='caozuo'>
          <span className="edit-btn" onClick={() => {
            if (record.loc_img) {
              setEditVisible({
                visible1: true,
                data: { ...record, loc_id: loc_id }
              })
            } else {
              Message.warning("请先抓图")
            }
          }}>编辑</span>
          <span className='img-load'>
            {
              imgLoading == record.device_id ?
                <Loading spinning={true} size="small" />
                : null
            }
            <span className={imgLoading == record.device_id ? "no-edit" : "edit-btn"} onClick={() => {
              if (imgLoading !== record.device_id) {
                getLocImg(record, record.device_id, index)
              }
            }}>抓图</span>
          </span>
        </div>
      }
    }
  ]

  // 获取抓图
  const getLocImg = (data, id, index) => {
    setImgLoading(id)
    ajax.getLocImg({
      code: data.device_id
    }).then(res => {
      if (res.status === 20000) {
        let arr = [...resultData.list]
        let obj = { ...data, loc_img: res.data.img }
        arr.splice(index, 1, obj)
        setResultData({
          list: arr,
          total: resultData.total
        })
        Message.success(res.message)
      } else {
        Message.error(res.message)
      }
      setImgLoading(-1)
    }).catch(err => console.log(err))
  }
  // 获取列表数据
  const getList = (params = formData) => {
    setTrue(true)
    setLastFormData(params)
    ajax.getDeviceList(params).then(res => {
      if (res.status === 20000) {
        setResultData(res.data)
      } else {
        Message.error(res.message)
      }
      setFalse(false)
    }).catch(err => console.log(err))
  }

  // 获取接收部门
  const getBusinessList = () => {
    ajax
      .getBusiness({
        module_type: type
      })
      .then((res) => {
        const { status, message, data } = res;
        if (status === 20000) {
          let arr = [{ label: "全部", value: "-1", children: data }]
          setBusinessList(arr);
        } else {
          Message.error(message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // 获取抓拍设备
  const getDeviceList = () => {
    ajax
      .getDeviceCapture({
        module_type: type
      })
      .then((res) => {
        const { status, message, data } = res;
        if (status === 20000) {
          let arr = [{ label: "全部", value: "-1", children: data }]
          setDevisceList(arr);
        } else {
          Message.error(message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // 获取抓拍设备
  const getLocList = () => {
    ajax
      .getLocList({
        module_type: type
      })
      .then((res) => {
        const { status, message, data } = res;
        if (status === 20000) {
          let arr = data.map(item => {
            return {
              value: item.locId,
              label: item.locName
            }
          })
          setLocList(arr);
        } else {
          Message.error(message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // 获取抓拍设备
  const updateLoc = () => {
    if (editVisible.data.loc_id === "") return Message.warning("请选择设备位置！")
    ajax
      .updateLoc({
        device_number: editVisible.data.device_id,
        loc_id: editVisible.data.loc_id
      })
      .then((res) => {
        const { status, message, data } = res;
        if (status === 20000) {
          Message.success(message);
          setEditView0Visible(false);
          setTimeout(() => {
            setEditVisible({
              visible: false,
              data: {}
            })
            getList(lastFormData)
          }, 1000);
        } else {
          Message.error(message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getBusinessList()
    getDeviceList()
    getList(formData)
    getLocList()
  }, [])
  const reset = () => {
    setFormData(defaultFormData)
    getList(defaultFormData)
  }
  useEffect(() => {
    const handleCalcHeight = () => {
      try {
        const resultHeight = document.querySelector(".table-box")
          ? document.querySelector(".table-box").clientHeight - 90
          : 0;
        const thHeight = document.querySelector(".ysd-table-header")
          ? document.querySelector(".ysd-table-header").clientHeight
          : 0;
        const toolHeight = 32 + 20;
        const height = resultHeight - thHeight - toolHeight;
        setTableScrollY(Math.max(height, 200));
      } catch (err) {
        console.log(err);
      }
    };
    handleCalcHeight();
    window.addEventListener("resize", handleCalcHeight);

    return () => {
      window.removeEventListener("resize", handleCalcHeight);
    };
  }, [resultData.total]);
  return <div className="equipment-page">
    <div className="search">
      <div className="title">查询条件</div>
      <FormTreeSelect
        labelPosition="top"
        yisaLabel="设备名称"
        placeholder="请选择设备名称"
        className="search-item"
        value={formData.device_name}
        onChange={(v) => changeValue(v, "device_name")}
        fieldNames={{ title: "label", key: "value" }}
        treeData={devisceList}
      />
      <FormTreeSelect
        labelPosition="top"
        yisaLabel="所属单位"
        placeholder="请选择所属单位"
        className="search-item"
        value={formData.business_name}
        onChange={(v) => changeValue(v, "business_name")}
        fieldNames={{ title: "label", key: "value" }}
        treeData={businessList}
      />
      <FormInput
        className="search-item"
        yisaLabel="设备编号"
        placeholder="请输入设备编号"
        value={formData.device_id}
        onChange={(v) => changeValue(v.target.value, "device_id")}
      />
      <FormSelect
        labelPosition="top"
        yisaLabel="设备状态"
        showClose
        options={[{
          label: "在线",
          value: "1",
        }, {
          label: "离线",
          value: "2",
        }]}
        showUnlimit={true}
        className="search-item"
        placeholder="请选择设备状态"
        value={formData.device_state}
        onChange={(v) => changeValue(v, "device_state")}
      />
      {/* <FormInput
        yisaLabel="设备位置"
        placeholder="请输入设备位置"
        value={formData.device_address}
        onChange={(v) => changeValue(v.target.value, "device_address")}
      /> */}

      <div className="search-btn-box">
        <Button className="reset-btn" onClick={reset}>
          重置
        </Button>
        <Button type="primary" className='search-btn' onClick={() => getList(formData)}>
          搜索
        </Button>

      </div>
    </div>
    <div className="table-box">
      <nav className="total">
        <p>
          共<span> {resultData.total || 0} </span>条结果
        </p>
        <Button className="export-btn" type="primary" onClick={() => setExportVisible(true)}>
          导出
        </Button>
      </nav>
      <ResultFlow
        loading={loading}
        resultData={resultData.list}
      >
        <div className="list">
          <Table
            className="table-warp"
            columns={columns}
            data={resultData.list}
            rowKey="id"
            bordered
            scroll={{
              y: tableScrollY
            }}
            loading={loading}
            pagination={false}
          />
        </div>
        <Pagination
          className="pagination-common"
          showQuickJumper
          showSizeChanger
          size='default'
          position={['bottomCenter']}
          current={lastFormData.page}
          total={resultData.total}
          pageSize={lastFormData.page_size}
          onChange={(page, pageSize) => {
            let obj = {};
            if (pageSize !== lastFormData.page_size) {
              obj.page = 1
              obj.page_size = pageSize
            } else {
              obj.page = page
            }
            let newParams = Object.assign({}, lastFormData, obj);
            getList(newParams)
          }}
          pageSizeOptions={character.pageSizeOptions}
        />

      </ResultFlow>
    </div>
    <Modal
      title='位置'
      className='edit-modal'
      // visible={editVisible.visible}
      visible={editView0Visible}
      width={520}
      maskClosable={false}
      okText="提交"
      cancelText="取消"
      onOk={() => {
        updateLoc()
      }}
      onCancel={() => {
        setEditView0Visible(false);
        setTimeout(() => {
          setEditVisible({
            visible: false,
            data: {}
          })
        }, 1000);
      }}
    >
      <div className="save-content">
        <div className="modal-form" >
          <div className="cc-form-name">
            <label className="required">*</label>
            <label>设备位置</label>
          </div>
          <div className="bottom">
            <Radio.Group
              className='radio-box'
              options={locList}
              value={editVisible.data.loc_id}
              onChange={(v) => setEditVisible({
                visible: true,
                data: {
                  ...editVisible.data,
                  loc_id: v.target.value
                }
              })}
            />
          </div>
        </div>
      </div>
    </Modal>
    <ROIModal
      visible={editView1Visible}
      data={editVisible.data}
      onCancel={() => {
        setEditView1Visible(false);
        setTimeout(() => {
          setEditVisible({
            visible1: false,
            data: {}
          })
        }, 1000);
      }}
    />
    <ExportModal
      total={resultData?.total}
      formData={{ ...lastFormData, page: "", page_size: "" }}
      visible={exportVisible}
      onCancel={() => { setExportVisible(false) }}
      url='/device/export'
      ajaxType="post"
      isUrl={false}
    />
    <BigImgSwitch
      visible={bigImgVisible}
      currentIndex={currentIndex}
      onCancel={() => setBigImgVisible(false)}
      yisaData={bigImgData}
      modalWidth={1400}
      changeNext={(v) => {
        setCurrentIndex(v);
      }}
      changePrev={(v) => {
        setCurrentIndex(v);
      }}
    />
  </div>
}

export default Equipment
